// tslint:disable
/**
 * Ux
 * insightux api
 *
 * The version of the OpenAPI document: 3.42
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TenorCustomFromJSON(json) {
    return {
        'length': !exists(json, 'length') ? undefined : json['length'],
        'tenorPeriod': !exists(json, 'tenorPeriod') ? undefined : json['tenorPeriod'],
    };
}
export function TenorCustomToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'length': value.length,
        'tenorPeriod': value.tenorPeriod,
    };
}
/**
* @export
* @enum {string}
*/
export var TenorCustomTenorPeriodEnum;
(function (TenorCustomTenorPeriodEnum) {
    TenorCustomTenorPeriodEnum["Month"] = "Month";
    TenorCustomTenorPeriodEnum["Quarter"] = "Quarter";
    TenorCustomTenorPeriodEnum["Year"] = "Year";
})(TenorCustomTenorPeriodEnum || (TenorCustomTenorPeriodEnum = {}));
